/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["body.theme-default[_ngcontent-%COMP%]   fuse-sidebar[_ngcontent-%COMP%] {\n  display: none; }\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi92YXIvd3d3L3Zob3N0cy90bXMuZGF5ZGV2YnVpbGQvc3JjL2FwcC9tYWluL2NvbWluZy1zb29uL2NvbWluZy1zb29uLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0ksYUFBWSxFQUFBIiwiZmlsZSI6InNyYy9hcHAvbWFpbi9jb21pbmctc29vbi9jb21pbmctc29vbi5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbImJvZHkudGhlbWUtZGVmYXVsdCBmdXNlLXNpZGViYXIge1xuICAgIGRpc3BsYXk6bm9uZTtcbn0iXX0= */"];
export { styles as styles };
